import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeDeleteDocType } from "../../domain/use-cases/delete-doc-type"
import { httpDocTypeRepository } from "../../data/repositories/doc-type-repository"

const deleteDocType = makeDeleteDocType(httpDocTypeRepository)

export const useDeleteDocType = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteDocType(id),
    onSuccess: (_, id) => {
      void qc.invalidateQueries({ queryKey: ["docTypes"] })
      void qc.invalidateQueries({ queryKey: ["docType", id] })
      void qc.invalidateQueries({ queryKey: ["documentUes"] })
    },
  })
}
